import { memo, useCallback, useEffect, useRef, useState } from 'react';
import styles from './input.module.css';
import Totals from './_Totals';
import { Divider, message, Table } from 'antd';
import { ReportProps } from '../Report';
import { Question } from '../QuestionsList';
import SurveysService from '../../SurveysService';
import { useScroll } from '../../../../components/hooks/useScroll';

type InputProps = Omit<ReportProps,'questions'> & {
    data: any
    question: Question
}

const Input = ({ data, question, client, surveyId, filters } : InputProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const [ responses, setResponses ] = useState<any[]>([...data.responses.sort((a: any,b: any) => b.created_at - a.created_at), { id: -1, text: 'divider' }]);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    
    const { scrolledToBottom } = useScroll({ elementRef: ref, selector: '.ant-table-body' });

    const loadMore = useCallback(async () => {
        setLoading(true);
        try {
            const offset = responses.length - 1;
            const data = await SurveysService.getTextResponsesPaged(client, surveyId, question.id, offset, filters);
            
            if(data.length < 20) setHasMore(false);
            const newResponses = [
                ...responses.slice(0,-1), 
                ...data, 
                { id: -1, text: 'divider' }];  
            setResponses(newResponses);
            ref.current?.querySelector('.ant-table-body')?.dispatchEvent(new Event('scroll'));
        }
        catch(err) {
            message.error('Ocurrió un error al consultar nuevos datos');
        }
        setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [responses]);

    useEffect(() => {
        if(scrolledToBottom && !loading && hasMore) loadMore();
    }, [scrolledToBottom, loading, hasMore, loadMore]);

    const renderFooter = () => {
        if(loading) {
            return <Divider plain>Cargando mas respuestas...</Divider>
        }
        else if(!hasMore) {
            
            return <Divider plain>No mas respuestas</Divider>
        }
        else return false;
    }
    

    return <div className={styles.container}>
        <Table ref={ref} size="small" columns={[
            {
                title: 'Texto',
                dataIndex: 'text',
                key: 'text',
                width: '100%',
                onCell: (_, index) => ({
                    colSpan: index === responses.length - 1 ? 2 : 1,
                }),
                render: (text: any, _, index) => {
                    if(index === responses.length - 1) {
                        return renderFooter();
                    }
                    else return text;
                }
            },
            {
                title: 'Fecha',
                dataIndex: 'created_at',
                key: 'created_at',
                width: 200,
                onCell: (_, index) => ({
                    colSpan: index === responses.length - 1 ? 0 : 1,
                }),
                render: (text: any) => new Date(text).toLocaleString()
            }
        ]} dataSource={responses} rowKey="id" pagination={false} scroll={{ y: 200 }} style={{margin:32}} />
        
        <Totals data={data} showAverage={false}/>
    </div>
};

export default memo(Input);